import { ReactNode, useEffect, useState } from 'react';

interface HydrationSafeProps {
  children: ReactNode;
}

export default function HydrationSafe({ children }: HydrationSafeProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Return null on first render, before hydration
  if (!mounted) {
    return null;
  }

  return <>{children}</>;
}
